import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { BsModalService } from 'ngx-bootstrap/modal';
import { RequestVersionUpdateComponent } from '../../components/request-version-update/request-version-update.component';
import { filter, withLatestFrom } from 'rxjs/operators';
import { ModalClass } from '../../enums/modal-bootstrap-classes.enum';
import { Observable, of } from 'rxjs';
import { EventService } from '../event/event.service';

@Injectable({
    providedIn: 'root',
})
export class AppUpdateService {
    public constructor(
        private updates: SwUpdate,
        private modalService: BsModalService,
        private readonly eventService: EventService,
    ) {}

    public init(): Observable<void> {
        this.updates.versionUpdates
            .pipe(
                filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
                withLatestFrom(this.eventService.appInitializationCompleted$),
            )
            .subscribe(([, initializationCompleted]) => {
                // checks if PACE is initialized if not yet, directly restarts to update SW
                if (initializationCompleted) {
                    this.showRequestVersionUpdateModal();
                } else {
                    window.location.reload();
                }
            });

        return of(undefined);
    }

    private showRequestVersionUpdateModal(): void {
        this.modalService.show(RequestVersionUpdateComponent, {
            class: ModalClass.MODAL_SMALL,
            ariaLabelledBy: 'request-version-update-modal-title',
        });
    }
}
